import firebase from 'firebase'
import axios from 'axios'
import { 
  influencerContentCreateApi,
  influencerContentUpdateApi,
  influencerContentGetDetailApi,
  influencerContentGetListApi
} from "@/config/appSettings"

// Save new campaign content
export const saveCampaignContent = async (data) => {
  try {
    const response = await axios.post(`${influencerContentCreateApi}`, JSON.stringify(data))
    return response
  } catch (error) {
    return error
  }
}

// Get list of Campaign Content by Campaign Id
export const getListOfCampaignContent = async (campaign) => {
  try {    
    const response = await axios.get(`${influencerContentGetListApi}/?usertoken=${firebase.auth().currentUser.uid}&campaign=${campaign}`)
    return response
  } catch (error) {
    return error
  }
}

// Get detail of Campaign Content by Content Id
export const getDetailOfCampaignContent = async (contentId) => {
  try {    
    const response = await axios.get(`${influencerContentGetDetailApi}/?usertoken=${firebase.auth().currentUser.uid}&content=${contentId}`)
    return response
  } catch (error) {
    return error
  }
}

// change status campaign content
export const changeStatusCampaignContent = async (data) => {
  try {
    const response = await axios.post(`${influencerContentUpdateApi}`, JSON.stringify(data))
    return response
  } catch (error) {
    return error
  }
}